"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TimeUtils {
    static getTimestamp() {
        return Date.now();
    }
    static getUTCISOTime() {
        return new Date().toISOString();
    }
}
exports.TimeUtils = TimeUtils;
//# sourceMappingURL=TimeUtils.js.map